import { HEALTH_ENROLLMENT_STATUSES } from 'platform/shared/health-apps';
import React from 'react';
import { useSelector } from 'react-redux';
import { createLiteralMap } from '../../../../utils/helpers';
import { selectParsedStatus } from '../../../../selectors';
import GeneralFAQs from '../ContentBlocks/GeneralFAQs';
import ReapplyFAQs from '../ContentBlocks/ReapplyFAQs';

const EnrollmentStatusFAQ = () => {
  const parsedStatus = useSelector(selectParsedStatus);

  const wrapContentBlocks = blocks =>
    blocks.map((jsx, i) => <React.Fragment key={i}>{jsx}</React.Fragment>);

  const contentDictionary = [
    [GeneralFAQs.faqBlock8, [HEALTH_ENROLLMENT_STATUSES.activeDuty]],
    [
      wrapContentBlocks([GeneralFAQs.faqBlock1, ReapplyFAQs.reapplyBlock1]),
      [HEALTH_ENROLLMENT_STATUSES.enrolled],
    ],
    [
      wrapContentBlocks([GeneralFAQs.faqBlock4, ReapplyFAQs.reapplyBlock2]),
      [HEALTH_ENROLLMENT_STATUSES.ineligCHAMPVA],
    ],
    [
      wrapContentBlocks([
        GeneralFAQs.faqBlock2,
        GeneralFAQs.faqBlock9,
        GeneralFAQs.faqBlock11,
        ReapplyFAQs.reapplyBlock2,
      ]),
      [HEALTH_ENROLLMENT_STATUSES.ineligCharacterOfDischarge],
    ],
    [
      wrapContentBlocks([GeneralFAQs.faqBlock2, ReapplyFAQs.reapplyBlock2]),
      [
        HEALTH_ENROLLMENT_STATUSES.ineligCitizens,
        HEALTH_ENROLLMENT_STATUSES.ineligFilipinoScouts,
      ],
    ],
    [
      wrapContentBlocks([GeneralFAQs.faqBlock5, ReapplyFAQs.reapplyBlock2]),
      [HEALTH_ENROLLMENT_STATUSES.ineligFugitiveFelon],
    ],
    [
      wrapContentBlocks([
        GeneralFAQs.faqBlock2,
        GeneralFAQs.faqBlock11,
        ReapplyFAQs.reapplyBlock2,
      ]),
      [
        HEALTH_ENROLLMENT_STATUSES.ineligGuardReserve,
        HEALTH_ENROLLMENT_STATUSES.ineligNotEnoughTime,
        HEALTH_ENROLLMENT_STATUSES.ineligTrainingOnly,
      ],
    ],
    [
      wrapContentBlocks([
        GeneralFAQs.faqBlock5,
        GeneralFAQs.faqBlock11,
        ReapplyFAQs.reapplyBlock2,
      ]),
      [
        HEALTH_ENROLLMENT_STATUSES.ineligMedicare,
        HEALTH_ENROLLMENT_STATUSES.ineligOther,
        HEALTH_ENROLLMENT_STATUSES.ineligOver65,
        HEALTH_ENROLLMENT_STATUSES.ineligRefusedCopay,
      ],
    ],
    [
      wrapContentBlocks([
        GeneralFAQs.faqBlock3,
        GeneralFAQs.faqBlock11,
        ReapplyFAQs.reapplyBlock2,
      ]),
      [HEALTH_ENROLLMENT_STATUSES.ineligNotVerified],
    ],
    [GeneralFAQs.faqBlock10, [HEALTH_ENROLLMENT_STATUSES.nonMilitary]],
    [
      wrapContentBlocks([GeneralFAQs.faqBlock6, ReapplyFAQs.reapplyBlock5]),
      [HEALTH_ENROLLMENT_STATUSES.pendingMt],
    ],
    [
      wrapContentBlocks([GeneralFAQs.faqBlock7, ReapplyFAQs.reapplyBlock6]),
      [
        HEALTH_ENROLLMENT_STATUSES.pendingOther,
        HEALTH_ENROLLMENT_STATUSES.pendingPurpleHeart,
      ],
    ],
    [
      wrapContentBlocks([GeneralFAQs.faqBlock12, GeneralFAQs.faqBlock7]),
      [HEALTH_ENROLLMENT_STATUSES.pendingUnverified],
    ],
    [
      wrapContentBlocks([
        GeneralFAQs.faqBlock5,
        GeneralFAQs.faqBlock11,
        ReapplyFAQs.reapplyBlock4,
      ]),
      [
        HEALTH_ENROLLMENT_STATUSES.rejectedIncWrongEntry,
        HEALTH_ENROLLMENT_STATUSES.rejectedRightEntry,
        HEALTH_ENROLLMENT_STATUSES.rejectedScWrongEntry,
        HEALTH_ENROLLMENT_STATUSES.canceledDeclined,
        HEALTH_ENROLLMENT_STATUSES.closed,
      ],
    ],
  ];

  const contentMap = createLiteralMap(contentDictionary);

  return contentMap[parsedStatus] || null;
};

export default EnrollmentStatusFAQ;
